import * as React from 'react';

function SvgLadder(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M4.5 1a.5.5 0 01.5.5V2h6v-.5a.5.5 0 011 0v14a.5.5 0 01-1 0V15H5v.5a.5.5 0 01-1 0v-14a.5.5 0 01.5-.5zM5 14h6v-2H5v2zm0-3h6V9H5v2zm0-3h6V6H5v2zm0-3h6V3H5v2z' />
		</svg>
	);
}

export default SvgLadder;
